import { createTheme } from "@material-ui/core";

const theme = createTheme({
  contactURL: "https://www.socialscavenger.com/contact.html",
  dangerColor: "#CE3031",
  headerPadding: "24px",
  infoColor: "#39c0ed",
  linkButtonColor: "rgba(0, 0, 0, 0.87)",
  maxMobileWidth: "767px",
  minDesktopWidth: "768px",
  navbarColor: "#1C1356",
  placeholderColor: "#f5f5f5",
  playerUrl: process.env.REACT_APP_PREVIEW_URL,
  primaryColor: "#1C1356",
  successColor: "#21DE93",
  warningColor: "#FF961B",
  headlinesColor: "#313131",
  accent1Color: "#DF20CC",
  accent2Color: "#1DBBDF",
  accent3Color: "#21DE93",
  accent4Color: "#FF961B",
  lightColor: "#F8F9FF",
  darkGreyColor: "#4F4F4F", 
  darkColor: "#1C1356",
  cardColor: "#E8F5FE",
  disabledColor: "#c8c8c8",
  realTimeDot: "#CE3031",
  white: "#FFF",
  black: "#000",
  rounded: {
    xs: "4px",
    sm: "7px",
    md: "14px",
    lg: "20px",
  },
  breakpoints: {
    values: {
      xs: 281,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
});

export default theme;
